import React from 'react';
export function PainBlock() {
  const painPoints = ['Hacés lo mismo de siempre y la balanza no se mueve. La menopausia cambió las reglas.', 'La panza crece aunque comas poco. Es inflamación hormonal, no calorías.', 'Te levantás cansada y te acostás cansada. Sin energía para nada.', 'Los sofocos y el sueño interrumpido arruinan tus días y tus noches.', 'Tu médico te dice "es la edad" como si no hubiera solución.', 'Evitás el espejo, evitás las fotos, evitás la ropa que amabas.'];
  return <div className="bg-[#0c0c0c] py-16 px-6" data-id="element-211">
      <div className="max-w-[960px] mx-auto" data-id="element-212">
        <p className="font-display text-[22px] sm:text-[3.5vw] md:text-[38px] text-center text-white mb-2 uppercase" data-id="element-213">
          ¿Cuántos lunes más vas a{' '}
          <span className="text-brand-green" data-id="element-214">empezar de nuevo?</span>
        </p>
        <p className="text-center text-brand-muted mb-9 text-[15px]" data-id="element-215">
          No es falta de voluntad. Es que nadie te dio el método correcto para
          esta etapa.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 mb-10" data-id="element-216">
          {painPoints.map((point, i) => <div key={i} className="bg-white/5 border border-brand-border rounded-lg py-4 px-4.5 flex items-start gap-3" data-id="element-217">
              <div className="w-[26px] h-[26px] bg-brand-red/15 border border-brand-red/30 rounded-full text-brand-red text-[13px] font-bold flex items-center justify-center shrink-0 mt-0.5" data-id="element-218">
                ✕
              </div>
              <p className="text-[13px] text-white/80 leading-relaxed" data-id="element-219">
                {point}
              </p>
            </div>)}
        </div>

        <p className="text-center font-display text-[22px] text-brand-green tracking-[1px] uppercase" data-id="element-220">
          ¿Y si esta fuera la última vez que pasó eso?
        </p>
      </div>
    </div>;
}